import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link, useI18next } from 'gatsby-plugin-react-i18next';

import * as styles from './style.module.scss';

const {
  latestResources,
  latestResources__image,
  latestResources__link,
  latestResources__text,
} = styles;

const contentTypes = {
  //ContentfulBlogPost: { label: 'Blog', url: '/blog' },
  ContentfulPlay: { label: 'Play', url: '/resources/playbooks' },
  //ContentfulPageSuccessStory: { label: 'Success Story', url: '/customers' },
};

const queryString = graphql`
  query {
    allContentfulPlay(sort: { datePublished: DESC }, limit: 20) {
      edges {
        node {
          __typename
          title
          slug: permalink
          image: headerImage {
            gatsbyImageData(placeholder: NONE, width: 592, height: 311)
          }
          language
          date: datePublished
          node_locale
        }
      }
    }
  }
`;

const LatestResourcesCTA = ({limit = 4}) => {
  const { language } = useI18next();
  const data = useStaticQuery(queryString);

  const {
    allContentfulPlay,
  } = data;

  const filterAndSort = (edges) =>
    edges
      .map((e) => e.node)
      .filter((node) => node.language === language)
      .sort((a, b) => new Date(b.date) - new Date(a.date));

  //const blogPostsAll = filterAndSort(allContentfulBlogPost.edges);
  //const successStoriesAll = filterAndSort(allContentfulPageSuccessStory.edges);
  const playsAll = filterAndSort(allContentfulPlay.edges);
  
  //const blogPosts = blogPostsAll.slice(0, 2);
  //const successStories = successStoriesAll.slice(0, 1);
  const plays = playsAll.slice(0, 1);
  
  let combined = [...plays];
  
  // Deduplicate by slug
  let dedupedMap = new Map(combined.map((item) => [item.slug, item]));
  let deduped = Array.from(dedupedMap.values());
  
  if (deduped.length < limit) {
    const allContent = [...playsAll];
    for (const item of allContent) {
      if (!dedupedMap.has(item.slug)) {
        dedupedMap.set(item.slug, item);
        deduped = Array.from(dedupedMap.values());
      }
      if (deduped.length === limit) break;
    }
  }
      
  return (
    <section className={latestResources}>
      {deduped.map((resource, index) => {
        const { __typename, image, slug, title } = resource;

        const url = `${contentTypes[__typename]?.url ?? ''}/${slug}`;

        const imageEl = index === 0 && (
          <GatsbyImage
            className={latestResources__image}
            quality={100}
            image={getImage(image)}
            alt={image?.description || title}
          />
        );

        return __typename === 'ContentfulPageSuccessStory' ? (
          <a key={`${slug}-${index}`} href={url} className={latestResources__link}>
            {imageEl}
            <p className={latestResources__text}>{title}</p>
          </a>
        ) : (
          <Link key={`${slug}-${index}`} to={url} className={latestResources__link}>
            {imageEl}
            <p className={latestResources__text}>{title}</p>
          </Link>
        );
      })}
    </section>
  );
};


export default LatestResourcesCTA;
